<div class="container">
    <div class="logo-container">
      <a routerLink="/services">
        <img class="logo" src="https://images.carriercms.com/image/upload/v1682690442/kidde/logos/Web/kidde-logo-140x44.png" alt="logo">
      </a>
    </div>
    <div class="user-container">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>account_circle</mat-icon>
      </button>
      <!-- <button mat-icon-button>
        <mat-icon>settings</mat-icon>
      </button> -->
      <button mat-icon-button (click)="logout()">
        <mat-icon>power_settings_new</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <span mat-menu-item class="user-name">{{userName | uppercase}}</span>
        <button mat-menu-item routerLink="/change-password">Change Password <mat-icon>password</mat-icon></button>
      </mat-menu>
    </div>
  </div>
  
    <mat-toolbar class="tool-bar-color">
       <div class="navigation">  
        <span class="spacer"></span>    
        <a mat-stroked-button routerLink="/dashboard" routerLinkActive="active-link">Home</a>
        <a mat-stroked-button routerLink="/services" routerLinkActive="active-link" >Services</a>
        <a mat-stroked-button routerLink="/alerts" routerLinkActive="active-link">Alerts</a>
        <a mat-stroked-button routerLink="/logs" routerLinkActive="active-link">Logs</a>
        <!-- <a mat-stroked-button routerLink="/OTA-upgrade" routerLinkActive="active-link">OTA</a> -->
        <!-- <a mat-stroked-button routerLink="/ota-dashboard" routerLinkActive="active-link">OTA</a> -->
        <a mat-stroked-button [matMenuTriggerFor]="otaMenu" [ngClass]="{'active-link': isOtaActive}" class="advertisement-button">
          <span class="button-content">
            OTA
            <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
          </span>
        </a>
        <mat-menu #otaMenu="matMenu">
           <button mat-menu-item (click)="navigate('/ota-device-key')">Keys</button>
          <button mat-menu-item (click)="navigate('/ota-dashboard')">OTA Job</button>
          <button mat-menu-item (click)="navigate('/ota-operations')">OTA Audit</button>
        </mat-menu>
        <a mat-stroked-button routerLink="/device-logs" routerLinkActive="active-link">Device Logs</a>
        <a mat-stroked-button [matMenuTriggerFor]="advertisementMenu" [ngClass]="{'active-link': isAdvertisementActive}" class="advertisement-button">
          <span class="button-content">
            Advertisement
            <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
          </span>
        </a>
        <mat-menu #advertisementMenu="matMenu">
          <button mat-menu-item (click)="navigate('/upload')">Banner/Explorer</button>
          <button mat-menu-item (click)="navigate('/notification-list')">Notification</button>
        </mat-menu>
        <a mat-stroked-button routerLink="/force-upgrade" routerLinkActive="active-link">App Release</a>
      </div>
        
    </mat-toolbar>